import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";
import { SET_SEARCH_ENGINE_STATUS } from '~/store/modules/searchEngine/types';
import isSearchEngine from '~/helpers/search-engine-helper';
export default {
  detectSearchEngine: function detectSearchEngine(_ref, userAgent) {
    var commit = _ref.commit;
    commit(SET_SEARCH_ENGINE_STATUS, isSearchEngine(userAgent));
  }
};